"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Geometric
 *
 * @param {*} start The number to start at
 * @param {*} commonRatio The number to multiply by each time
 *
 * Produces a geometric number sequence. Geometric number
 * sequences are sequences which multiply or divide by a certain
 * amount for each iteration.
 */
// Public API
exports.default = function (start, commonRatio) {
  return (0, immutable_1.Seq)(generator(start, commonRatio));
};
// Generator
function generator() {
  var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var commonRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return regeneratorRuntime.wrap(function generator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return current;

        case 2:
          return _context.delegateYield(generator(current * commonRatio, commonRatio), "t0", 3);

        case 3:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, this);
}
//# sourceMappingURL=geometric.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/geometric.js
// module id = 276
// module chunks = 0